module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609970005001"
    }
  }), _c('h2', {
    staticClass: "chapter-title"
  }, [_vm._v("Contents")]), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('a', {
    attrs: {
      "href": "#/ch005#p9000f1609970007001"
    }
  }, [_vm._v("Introduction ")]), _c('a', {
    attrs: {
      "href": "#/ch005#p9000f1609970007001"
    }
  }, [_vm._v(" 6")])])])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "50%"
    }
  })])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-part-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ch006#p9000f1609970008001"
    }
  }, [_vm._v("Day Time")]), _c('a', {
    attrs: {
      "href": "#/ch006#p9000f1609970008001"
    }
  }, [_vm._v(" 8")])])])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "25%"
    }
  })])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('a', {
    attrs: {
      "href": "#/ch007#p9000f1609970010001"
    }
  }, [_vm._v("Shabby Chic")]), _c('a', {
    attrs: {
      "href": "#/ch007#p9000f1609970010001"
    }
  }, [_vm._v(" 10")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch008#p9000f1609970022001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Girl About Town")]), _c('span', {
    attrs: {
      "href": "#/ch008#p9000f1609970022001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 22")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch009#p9000f1609970028001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nature Girl")]), _c('span', {
    attrs: {
      "href": "#/ch009#p9000f1609970028001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 28")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch010#p9000f1609970034001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moody Blues")]), _c('span', {
    attrs: {
      "href": "#/ch010#p9000f1609970034001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 34")])])])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "50%"
    }
  })])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-part-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch011#p9000f1609970040001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Play Time")]), _c('span', {
    attrs: {
      "href": "#/ch011#p9000f1609970040001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 40")])])])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "25%"
    }
  })])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch012#p9000f1609970042001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunny Afternoon")]), _c('span', {
    attrs: {
      "href": "#/ch012#p9000f1609970042001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 42")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch013#p9000f1609970050001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bon Voyage")]), _c('span', {
    attrs: {
      "href": "#/ch013#p9000f1609970050001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 50")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch014#p9000f1609970056001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shopaholic!")]), _c('span', {
    attrs: {
      "href": "#/ch014#p9000f1609970056001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 56")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch015#p9000f1609970064001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glitz & Glamour")]), _c('span', {
    attrs: {
      "href": "#/ch015#p9000f1609970064001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 64")])])])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "50%"
    }
  })])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-part-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ch016#p9000f1609970068001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home Time")]), _c('span', {
    attrs: {
      "href": "#/ch016#p9000f1609970068001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 68")])])])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "25%"
    }
  })])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch017#p9000f1609970070001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wash Day Pinks ")]), _c('span', {
    attrs: {
      "href": "#/ch017#p9000f1609970070001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 70")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch018#p9000f1609970078001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ladies’ Day")]), _c('span', {
    attrs: {
      "href": "#/ch018#p9000f1609970078001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 78")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch019#p9000f1609970086001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Going Green")]), _c('span', {
    attrs: {
      "href": "#/ch019#p9000f1609970086001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 86")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch020#p9000f1609970092001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arts and Flowers ")]), _c('span', {
    attrs: {
      "href": "#/ch020#p9000f1609970092001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 92")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch021#p9000f1609970100001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Techniques")]), _c('span', {
    attrs: {
      "href": "#/ch021#p9000f1609970100001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 100")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch028#p9000f1609970116001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Templates")]), _c('span', {
    attrs: {
      "href": "#/ch028#p9000f1609970116001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 116")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch029#p9000f1609970126001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")]), _c('span', {
    attrs: {
      "href": "#/ch029#p9000f1609970126001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 126")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch030#p9000f1609970127001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")]), _c('span', {
    attrs: {
      "href": "#/ch030#p9000f1609970127001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 127")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch031#p9000f1609970127002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _c('span', {
    attrs: {
      "href": "#/ch031#p9000f1609970127002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 127")])])])]), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-term"
  }, [_c('span', {
    attrs: {
      "href": "#/ch032#p9000f1609970128001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('span', {
    attrs: {
      "href": "#/ch032#p9000f1609970128001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 128")])])])])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609960006001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f160g6001.png",
      "width": "88.56625%"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c2626ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch004.vue
// module id = 66
// module chunks = 0